import { useEffect } from 'react';

/**
 * Locks body scroll while the `locked` flag is true.
 *
 * Uses a module-level ref counter so that nested modals do not
 * prematurely unlock the body when an inner modal closes while
 * an outer one is still open. The original `body.style.overflow`
 * value is captured on the first lock and restored when the last
 * lock is released.
 *
 * Fixes AB#1329.
 */

let lockCount = 0;
let originalOverflow: string | null = null;

export const useBodyScrollLock = (locked: boolean): void => {
    useEffect(() => {
        if (!locked) {
            return;
        }

        if (lockCount === 0) {
            originalOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
        }
        lockCount += 1;

        return () => {
            lockCount -= 1;
            if (lockCount <= 0) {
                lockCount = 0;
                document.body.style.overflow = originalOverflow ?? '';
                originalOverflow = null;
            }
        };
    }, [locked]);
};

export default useBodyScrollLock;
